jQuery(function ($) {
    $(document).ajaxComplete(function(event, xhr, settings) {
        // Check if the request was the Wordfence authentication call
        if (settings.data && settings.data.indexOf('action=wordfence_ls_authenticate') !== -1) {
            console.log('Wordfence authentication request detected');

            // We add a tiny delay to ensure Wordfence has finished
            // injecting the error message into the DOM
            setTimeout(function() {
                console.log('Wordfence authentication request complete');
                if ($('.woocommerce-error li').length > 0) {
                    console.log('Wordfence authentication error detected');
                    $('.spinner-main').removeClass('loaded');
                }
            }, 100);
        }
    });
});